<template>
	<div class="comp">
		<div class="title">
			<div class="titleL">收货地址</div>
			<div class="titleR">
				<el-button type="text" size="mini" @click="add">新增收货地址</el-button>
			</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" height="100%" >
				<el-table-column prop="user_name" label="收货人" width="110">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" width="120">
				</el-table-column>
				<el-table-column  label="地区">
					<template slot-scope="scope">
						{{scope.row.province_name}} {{scope.row.city_name}} {{scope.row.district_name}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="详细地址">
				</el-table-column>
				<el-table-column prop="address" label="是否默认" width="80">
					<template slot-scope="scope">
						{{scope.row.is_default===1?'默认':''}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="edit(scope.row)">修改</el-button>
						<el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="dialogAddShipAddress_state">
			<dialogAddShipAddress :curRow="curRow" @submit="submit_dialogAddShipAddress"></dialogAddShipAddress>
		</div>
	</div>
</template>

<script>
	import dialogAddShipAddress from "./dialog_addShipAddress.vue"
	export default {
		components:{dialogAddShipAddress},
		data() {
			return {
				tableData:[],
				
				dialogAddShipAddress_state:false,
				curRow:{},
				
			}
		},
		mounted(){
			this.getTableData()
		},
		methods:{
			add(){
				this.curRow = {}
				this.dialogAddShipAddress_state = true;
			},
			edit(row){
				this.curRow = row
				this.dialogAddShipAddress_state = true;
			},
			submit_dialogAddShipAddress(obj){
				this.dialogAddShipAddress_state = false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			del(row){
				this.$confirm('确定删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_livingMall+'/api/ShipAddress/Delete', {
						id:row._id
					}).then(res => {
						loading.close()
						if(res.code===0){
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getTableData()
						}
					})
					
				})
			},
			//获取表格
			getTableData(){
				let params = {}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/ShipAddress/list', params).then(res => {
					loading.close()
					if(res.code===0){
						this.tableData = res.data
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
.comp{
	height:100%;
	// .title{
	// 	display: flex;justify-content: space-between;padding:0 0 20px;
	// 	.titleL{
	// 		font-size: 16px;color:#575757;border-left:4px solid #FF9720;padding-left:10px;line-height: 28px;
	// 	}
	// 	.titleR{
			
	// 	}
	// }
	.title{
		display: flex;justify-content: space-between;padding:0 0 10px;border-bottom: 1px solid #E8E8EB;
		.titleL{
			font-size: 20px;color:#303042;padding-left:10px;line-height: 28px;
		}
		.titleR{
			
		}
	}
	.tableBox{
		height: 600px;
	}
}
</style>							
